import UserLogin from '@/pages/UserLogin/components/FromLogin' // 登录
import FromPasRes from '@/pages/UserLogin/components/FromPasRes' // 修改密码
import PageNotFound from '@/components/PageNotFound' // 404
import NoPms from '@/pages/PartI/NoPms' // 404


// 统计
import Statistics from "@/pages/PartI/Statistics"
// 单位管理
import UnitManagement from "@/pages/PartI/UnitManagement"
// 权限包
import PermissionPackage from "@/pages/PartI/PermissionPackage"
// 运营帐号
import OperationAccount from "@/pages/PartI/OperationAccount"
// 纪念堂管理
import SpaceManagement from "@/pages/PartII/SpaceManagement"
// 用户管理
import UserManagement from "@/pages/PartII/UserManagement"
// 线上订单
import OnlineOrder from "@/pages/PartII/OnlineOrder"
// 纪念堂详情
import SpaceDetails from "@/pages/PartII/SpaceDetails"

// 支付
import Pay from "@/pages/Pay/pay"
// 个人信息
import PersonalDetails from "@/pages/PersonalDetails/PersonalDetails"
// 纪念堂信息
import WxSpaceDetails from "@/pages/WxSpaceDetails/WxSpaceDetails"
// 视频播放
import Video from "@/pages/Video/Video"
// 上传记录
import UpdateRecord from "@/pages/UpdateRecord/UpdateRecord"
// app管理
import AppManage from "@/pages/PartI/AppManage"
// H5微信授权申请
import OauthApply from "@/pages/OauthApply/OauthApply"
// H5用户协议
import UserAgreement from "@/pages/UserAgreement/UserAgreement"
// 扫墓
import Sweep from "@/pages/Sweep/Sweep"
// 企微扫墓
import WxSweep from "@/pages/WxSweep/WxSweep"

export default [{
    path: '/userlogin',
    name: 'UserLogin',
    component: UserLogin,
    meta: {
      title: "登录"
    }
  },
  {
    path: '/pagenotfound',
    name: 'PageNotFound',
    component: PageNotFound,
    meta: {
      title: "没有找到该页面"
    }
  }, 
  {
    path: '*',
    redirect: '/pagenotfound'
  },
  {
    path: '/nopms',
    name: 'noPms',
    component: NoPms,
    meta: {
      title: "无页面访问权限"
    }
  }, 
   {
    path: '/frompasres',
    name: 'FromPasRes',
    component: FromPasRes,
    meta: {
      title: "重置密码"
    }
  },
  {
    path: '/statistics',
    name: 'statistics',
    component: Statistics,
    meta: {
      title: "统计"
    }
  },
  {
    path: '/unit',
    name: 'UnitManagement',
    component: UnitManagement,
    meta: {
      title: "单位管理"
    }
  }, {
    path: '/permission',
    name: 'PermissionPackage',
    component: PermissionPackage,
    meta: {
      title: "岗位管理"
    }
  }, {
    path: '/operation',
    name: 'OperationAccount',
    component: OperationAccount,
    meta: {
      title: "运营帐号"
    }
  }, {
    path: '/space',
    name: 'SpaceManagement',
    component: SpaceManagement,
    meta: {
      title: "纪念堂管理"
    }
  }, {
    path: '/user',
    name: 'UserManagement',
    component: UserManagement,
    meta: {
      title: "用户管理"
    }
  }, {
    path: '/order',
    name: 'OnlineOrder',
    component: OnlineOrder,
    meta: {
      title: "线上订单"
    }
  }, {
    path: '/spacedetails',
    name: 'SpaceDetails',
    component: SpaceDetails,
    meta: {
      title: "纪念堂详情"
    }
  }, 
  {
    path: '/pay',
    name: 'Pay',
    component: Pay,
    meta: {
      title: "支付"
    }
  },
   {
    path: '/personaldetails',
    name: 'PersonalDetails',
    component: PersonalDetails,
    meta: {
      title: "个人信息"
    }
  }, {
    path: '/wxspacedetails',
    name: 'WxSpaceDetails',
    component: WxSpaceDetails,
    meta: {
      title: "纪念堂详情"
    }
  },{
    path: '/video',
    name: 'Video',
    component: Video,
    meta: {
      title: "视频播放"
    }
  },{
    path: '/updaterecord',
    name: 'UpdateRecord',
    component: UpdateRecord,
    meta: {
      title: "上传记录"
    }
  },{
    path: '/app',
    name: 'app',
    component: AppManage,
    meta: {
      title: "APP管理"
    }

  }, {
    path: '/oauthapply',
    name: 'OauthApply',
    component: OauthApply,
    meta: {
      title: "H5微信授权申请"
    }
  }, {
    path: '/useragreement',
    name: 'UserAgreement',
    component: UserAgreement,
    meta: {
      title: "H5用户协议"
    }
  },{
    path: '/sweep',
    name: 'Sweep',
    component: Sweep,
    meta: {
      title: "扫墓"
    }
  }, {
    path: '/wxsweep',
    name: 'WxSweep',
    component: WxSweep,
    meta: {
      title: "企微扫墓"
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/path.js